import team01 from '../../../../Images/team/student-01.jpeg';
import team02 from '../../../../Images/team/student-02.jpg';
import team04 from '../../../../Images/team/student-04.jpg';
import team12 from '../../../../Images/team/student-12.jpg';
import SectionTitle from '../../../SectionTitle/SectionTitle';
import './AdBoard.css';

const AdBoard = () => {
  return (
    <>
      <section className='Ad_Boarder_bg py-16'>
        <div className='container p-6 mx-auto'>
          <SectionTitle subtitle='Our Teams' title='Meet Our Expert Teams' />
          <div className='grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4 xl:grid-cols-4'>
            <div className='text-center border bg-white  border-[#E0E5EB] rounded-[15px] team-card'>
              <div className='team-thumb-wrap'>
                <div className='team-thumb'>
                  <img src={team01} alt='team' />
                </div>
              </div>
              <div className='team-content'>
                <h1 className='text-[18px] font-bold hover:text-[#1bb57b] cursor-pointer capitalize'>
                  M. SOLAIMAN
                </h1>
                <p className='text-primary text-[15px]'>Founder</p>
              </div>
            </div>
            <div className='text-center border bg-white  border-[#E0E5EB] rounded-[15px] team-card'>
              <div className='team-thumb-wrap'>
                <div className='team-thumb'>
                  <img src={team02} alt='team' />
                </div>
              </div>
              <div className='team-content'>
                <h1 className='text-[18px] font-bold hover:text-[#1bb57b] cursor-pointer capitalize'>
                  Md Jewel Rana
                </h1>
                <p className='text-primary text-[15px]'>Co-Founder & CEO</p>
              </div>
            </div>
            <div className='text-center border bg-white  border-[#E0E5EB] rounded-[15px] team-card'>
              <div className='team-thumb-wrap'>
                <div className='team-thumb'>
                  <img src={team12} alt='team' />
                </div>
              </div>
              <div className='team-content'>
                <h1 className='text-[18px] font-bold hover:text-[#1bb57b] cursor-pointer capitalize'>
                  Hridoy mia
                </h1>
                <p className='text-primary text-[15px]'>Manager</p>
              </div>
            </div>
            <div className='text-center border bg-white  border-[#E0E5EB] rounded-[15px] team-card'>
              <div className='team-thumb-wrap'>
                <div className='team-thumb'>
                  <img src={team04} alt='team' />
                </div>
              </div>
              <div className='team-content'>
                <h1 className='text-[18px] font-bold hover:text-[#1bb57b] cursor-pointer capitalize'>
                  Md Mamun Mia
                </h1>
                <p className='text-primary text-[15px]'>Accountant</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AdBoard;
